import React from 'react';
import { Link } from 'react-router-dom';
import { inventoryCategories } from '../../data/inventory';
export function InventoryFooter() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-900 text-white border-t border-white/5 mt-auto" data-id="element-59">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12" data-id="element-60">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-61">
          {/* Column 1: Inventory Categories */}
          <div data-id="element-62">
            <h3 className="text-sm font-bold uppercase tracking-wider text-cg-orange-600 mb-6" data-id="element-63">
              Categories
            </h3>
            <ul className="space-y-3" data-id="element-64">
              {inventoryCategories.map(category => <li key={category.slug} data-id="element-65">
                  <Link to={`/inventory/${category.slug}`} className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-66">
                    {category.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Column 2: Support */}
          <div data-id="element-67">
            <h3 className="text-sm font-bold uppercase tracking-wider text-cg-orange-600 mb-6" data-id="element-68">
              Support
            </h3>
            <ul className="space-y-3" data-id="element-69">
              <li data-id="element-70">
                <Link to="/contact" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-71">
                  Contact Support
                </Link>
              </li>
              <li data-id="element-72">
                <a href="mailto:orders@chilternglobal.com" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-73">
                  Order Enquiries
                </a>
              </li>
              <li data-id="element-74">
                <Link to="/contact" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-75">
                  Bulk Procurement
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Legal */}
          <div data-id="element-76">
            <h3 className="text-sm font-bold uppercase tracking-wider text-cg-orange-600 mb-6" data-id="element-77">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-78">
              <li data-id="element-79">
                <Link to="/privacy-policy" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-80">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-81">
                <Link to="/terms-of-service" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-82">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/cookie-policy" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-84">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 mt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-85">
          <p className="text-steel-500 text-xs" data-id="element-86">
            © {currentYear} Chiltern Global. All rights reserved.
          </p>
          <p className="text-steel-600 text-xs" data-id="element-87">Inventory System v2.0</p>
        </div>
      </div>
    </footer>;
}